angular.module('rjmNg.directives').directive "sqlEditor", [
  () ->
    restrict: "E"
    templateUrl: "directive.sqlEditor.html"
    replace: false
    controllerAs: "view"
    bindToController: true
    scope:
      editor: "="
      query: "="
    controller: [
      "$scope"
      "$rootScope"
      (
        $scope
        $rootScope
      ) ->

        view = @

        view.getQuery = () ->
          view.query = view.editor.getValue()
          return view.query

        view.setQuery = (query) ->
          view.query = query
          view.editor.setValue(query)

        view.insertTextIntoSQLQuery = (text) ->
          view.editor.replaceSelection(text)

        view.run = () ->
          $rootScope.$broadcast 'runSqlQuery'

        $scope.$on 'insertTextIntoSQLQuery', (event, text) ->
          view.insertTextIntoSQLQuery(text)
          view.editor.focus()

        view
    ]
    link: (scope, elem, attrs, view) ->
      options =
        lineNumbers: true
        lineWrapping: true
        mode: "text/x-sql"
        extraKeys:
          "Shift-Enter": () -> view.run()

      view.textArea = $(elem).find('textarea')[0]
      view.textArea.value = ''
      view.query = view.textArea.value
      view.editor = CodeMirror.fromTextArea(view.textArea, options)
]
